import React from 'react';

const GoogleIcon = ({
  color = '#FF8A1F',
  size = 12,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19.4057 8.12475C19.5307 8.79419 19.5987 9.49411 19.5987 10.2245C19.5987 15.9376 15.7751 20 10 20C8.68667 20.0004 7.38613 19.742 6.17269 19.2396C4.95925 18.7372 3.8567 18.0006 2.92804 17.072C1.99937 16.1433 1.26279 15.0407 0.76039 13.8273C0.257984 12.6139 -0.000399962 11.3133 4.64701e-07 10C-0.000399962 8.68667 0.257984 7.38613 0.76039 6.17269C1.26279 4.95926 1.99937 3.8567 2.92804 2.92804C3.8567 1.99937 4.95925 1.26279 6.17269 0.76039C7.38613 0.257984 8.68667 -0.000399962 10 4.64701e-07C12.7001 4.64701e-07 14.9563 0.993499 16.6873 2.60666L13.8683 5.42564V5.41853C12.819 4.41893 11.4872 3.90593 10 3.90593C6.70053 3.90593 4.01869 6.69342 4.01869 9.99391C4.01869 13.2934 6.70053 16.087 10 16.087C12.9937 16.087 15.0315 14.3753 15.45 12.0246H10V8.12475H19.4067H19.4057Z" fill={color} />
    </svg>
  );
};

export default GoogleIcon;
